import { efaProductDetails } from './efa-product-details-en.i18n';

export const en = {
  efaProductDetails
};
